// INITIALIZE

var icons = [];

// PUSH

icons.push('search', 'to-top', 'add', 'minute', 'close');
icons.push('social/facebook', 'social/youtube', 'social/twitter', 'social/instagram', 'social/facebook-share', 'social/facebook-messenger');
icons.push('lang/vi', 'lang/en', 'lang/th');
icons.push('tournament/format','tournament/game-mode','tournament/location','tournament/prize-pool','tournament/starting-date','tournament/trophy')
icons.push('file-upload', 'check');
icons.push('play', 'focus', 'fullscreen', 'slide', 'captain');


// FUNCTION

icons.forEach(function(v) {
	$('.icon[data-icon="'+v+'"]').html(require('../icons/'+v+'.svg'));
}); 